// Module
var code = `<iframe iframe-set-dimensions-onload class="web-app-adapter" frameborder="0" ng-src="{{webAppAdapterCtrl.wrappedUrl}}"> </iframe>`;
// Exports
export default code;